import { getColorTheme } from 'utils/funcaoPadrao';

export const getOptions = title => {
  return {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          color: getColorTheme('textoColor'),
        },
      },
      title: {
        display: true,
        text: `${title}`,
        color: getColorTheme('textoColor'),
        font: {
          size: '20px',
          weight: 'bold',
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          title: tooltipItems => {
            return tooltipItems[0].dataset.label;
          },
          label: context => {
            let label = '';
            if (context.parsed) {
              label = context.raw;
            }
            return label;
          },
        },
      },
      datalabels: {
        color: getColorTheme('textoColor'),
        formatter: value => {
          return `${value}`;
        },
        anchor: 'center',
        labels: {
          value: {
            font: {
              size: '15px',
            },
            color: getColorTheme('textoColor'),
          },
        },
      },
    },
  };
};

export const plugin = {
  id: 'GraficoBarrasVerticalComponenteCanvas',
  beforeDraw: chart => {
    const { ctx } = chart;
    ctx.save();
    ctx.globalCompositeOperation = 'destination-over';
    ctx.fillStyle = getColorTheme('bottomColorSefaz');
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  },
};

export const handleDownloadImage = (title, ref) => {
  const link = document.createElement('a');
  const name = `${title.replace(' ', '-')}.png`;
  link.download = name;
  link.href = ref.current.toBase64Image();
  link.click();
  return name;
};
